<div class="flex flex-col h-full">
  <!-- Indicador de Save -->
  <div *ngIf="showSaveIndicator" class="fixed top-4 right-4 z-50 bg-white border border-gray-300 rounded-lg shadow-lg p-3 flex items-center space-x-2">
    <app-loading-spinner *ngIf="saveIndicatorText.includes('Salvando')" size="xs"></app-loading-spinner>
    <div *ngIf="saveIndicatorText.includes('sucesso')" class="text-green-600">
      <i class="fas fa-check-circle"></i>
    </div>
    <div *ngIf="saveIndicatorText.includes('Erro')" class="text-red-600">
      <i class="fas fa-exclamation-circle"></i>
    </div>
    <span class="text-sm font-medium" [ngClass]="{
      'text-westetics-purple-800': saveIndicatorText.includes('Salvando'),
      'text-green-600': saveIndicatorText.includes('sucesso'),
      'text-red-600': saveIndicatorText.includes('Erro'),
      'text-gray-600': !saveIndicatorText.includes('Salvando') && !saveIndicatorText.includes('sucesso') && !saveIndicatorText.includes('Erro')
    }">
      {{ saveIndicatorText }}
    </span>
  </div>

  <!-- HEADER V2 - Card Branco -->
  <div *ngIf="treatmentPlan" class="bg-white rounded-lg border border-gray-200 p-4 mb-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
    <div class="flex flex-col">
      <span class="text-lg font-semibold text-westetics-neutral-950">{{ treatmentPlan.patient_name || 'Plano de Tratamento' }}</span>
      <div class="flex items-center gap-2 text-sm text-westetics-neutral-600">
        <span class="px-2 py-0.5 rounded-full text-xs" [ngClass]="{'bg-westetics-purple-100 text-westetics-purple-800': treatmentPlan.status === 'ACTIVE', 'bg-green-100 text-green-800': treatmentPlan.status !== 'ACTIVE'}">
          {{ treatmentPlan.status === 'ACTIVE' ? 'Em Aberto' : 'Encerrado' }}
        </span>
        <span *ngIf="treatmentPlan?.responsible_professional">• {{ treatmentPlan.responsible_professional }}</span>
      </div>
      <!-- Indicador de fotos sendo enviadas -->
      <div *ngIf="hasAnyProductPhotoUploading()" class="flex items-center text-westetics-purple-800 mt-1">
        <app-loading-spinner size="xs" class="mr-2"></app-loading-spinner>
        <span class="text-sm">Enviando fotos...</span>
      </div>
    </div>

    <div class="flex flex-wrap gap-2">
      <!-- Botão Encerrar -->
      <div class="relative">
        <button #closeButton *ngIf="treatmentPlan && treatmentPlan.status === 'ACTIVE'" (click)="closeTreatmentPlan()"
          class="px-4 py-2 text-sm font-medium text-white rounded-lg transition-colors bg-westetics-purple-800 hover:bg-westetics-purple-600">
          Encerrar
        </button>
      </div>

      <!-- Botão PDF -->
      <button *ngIf="treatmentPlan && treatmentPlan.status !== 'ACTIVE'"
        (click)="downloadPdf()"
        [disabled]="loading || downloadingPdf"
        class="px-4 py-2 text-sm font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center">
        <span *ngIf="!downloadingPdf">Baixar PDF</span>
        <span *ngIf="downloadingPdf" class="flex items-center">
          Gerando PDF...
        </span>
      </button>

      <!-- Botão Reenviar por Email (apenas para planos encerrados) -->
      <button *ngIf="treatmentPlan && treatmentPlan.status === 'CLOSED'" 
        (click)="sendPdfByEmail()"
        [disabled]="sendingEmail || loading"
        class="px-4 py-2 text-sm font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
        <span *ngIf="!sendingEmail">Reenviar por Email</span>
        <span *ngIf="sendingEmail" class="flex items-center">
          <app-loading-spinner size="xs" class="mr-2"></app-loading-spinner>
          Enviando...
        </span>
      </button>

      <!-- Botão Salvar -->
      <button *ngIf="treatmentPlan && treatmentPlan.status === 'ACTIVE'" (click)="forceSave('manual_save')"
        [disabled]="showSavingIndicator || loading"
        class="px-4 py-2 text-sm font-medium bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white  rounded-lg  transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed">
        {{ showSavingIndicator ? 'Salvando...' : 'Salvar' }}
      </button>
    </div>
  </div>

  <!-- Wrapper interno para conteúdo -->
  <div class="w-full">
    <div [hidden]="!loading">
    <app-loading></app-loading>
  </div>

  <!-- Saving overlay -->
    <div *ngIf="showSavingIndicator" class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div class="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center">
        <app-loading-spinner size="lg" class="mb-4"></app-loading-spinner>
        <p class="text-lg font-medium">Salvando plano de tratamento...</p>
      </div>
    </div>

    <!-- Conteúdo principal -->
    <div *ngIf="!loading && treatmentPlan">
      <!-- Mensagem de sucesso/erro -->
      <div *ngIf="showMessage"
        class="fixed top-5 right-5 p-4 rounded-lg shadow-2xl z-[9999] max-w-md transition-all duration-300" [ngClass]="{
          'bg-green-50 border-2 border-green-500 text-green-800': messageType === 'success',
          'bg-red-50 border-2 border-red-500 text-red-800': messageType === 'error'
        }"
        style="background-color: rgba(255, 255, 255, 1) !important;">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <i *ngIf="messageType === 'success'" class="fas fa-check-circle text-green-500 text-lg"></i>
            <i *ngIf="messageType === 'error'" class="fas fa-exclamation-circle text-red-500 text-lg"></i>
          </div>
          <div class="ml-3 flex-1">
            <p class="text-sm font-semibold">{{ messageText }}</p>
          </div>
          <div class="ml-auto pl-3">
            <div class="-mx-1.5 -my-1.5">
              <button (click)="closeMessage()" class="inline-flex rounded-full p-1.5 hover:bg-gray-100 transition-colors" [ngClass]="{
                  'text-green-600 hover:text-green-800': messageType === 'success',
                  'text-red-600 hover:text-red-800': messageType === 'error'
                }">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Mensagem informativa sobre campos obrigatórios - exibida somente quando o botão de ajuda é clicado -->
      <div *ngIf="treatmentPlan.status === 'ACTIVE'"
        class="overflow-hidden transition-all duration-[450ms] ease-in-out"
        [style.max-height]="showHelpInfoVisible ? '500px' : '0'"
        [style.margin-bottom]="showHelpInfoVisible ? '1.5rem' : '0'">
        <div class="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-md shadow-sm relative">
          <button (click)="showHelpInfoVisible = false" class="absolute top-2 right-2 text-blue-500 hover:text-blue-700">
            <i class="fas fa-times"></i>
          </button>
          <div class="flex">
            <div class="flex-shrink-0">
              <i class="fas fa-info-circle text-blue-500"></i>
            </div>
            <div class="ml-3">
              <p class="text-sm text-blue-700">
                <span class="font-medium">Sistema de salvamento flexível:</span>
                Você pode salvar o plano de tratamento a qualquer momento, mesmo com campos obrigatórios em branco.
              </p>
              <p class="text-sm text-blue-700 mt-2">
                <span class="font-medium">Campos obrigatórios para encerramento:</span>
              </p>
              <ul class="list-disc ml-5 mt-1 text-sm text-blue-700">
                <li><strong>Informações Gerais:</strong> Idade do paciente</li>
                <li><strong>Produtos (opcional):</strong> Se houver produtos, é necessário preencher dados básicos (fabricante, produto, datas), regiões de aplicação e pelo menos uma foto por produto</li>
              </ul>
              <p class="text-sm text-blue-700 mt-2">
                <span class="font-medium">Nota:</span> O plano só pode ser encerrado quando todos os campos obrigatórios estiverem preenchidos.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Abas -->
      <div class="flex flex-col md:flex-row md:justify-between border-b border-gray-200 mb-6">
        <nav class="flex overflow-x-auto -mb-px hide-scrollbar">
          <button (click)="changeTab('info')"
            class="py-3 md:py-4 px-4 md:px-6 font-medium text-sm border-b-2 focus:outline-none whitespace-nowrap"
            [ngClass]="{'border-westetics-purple-800 text-westetics-purple-800': activeTab === 'info', 'border-transparent text-gray-500 hover:text-gray-700': activeTab !== 'info'}">
            Informações Gerais
          </button>
          <button (click)="changeTab('products')"
            class="py-3 md:py-4 px-4 md:px-6 font-medium text-sm border-b-2 focus:outline-none whitespace-nowrap"
            [ngClass]="{'border-westetics-purple-800 text-westetics-purple-800': activeTab === 'products', 'border-transparent text-gray-500 hover:text-gray-700': activeTab !== 'products'}">
            Produtos
          </button>
          <button (click)="changeTab('photos')"
            class="py-3 md:py-4 px-4 md:px-6 font-medium text-sm border-b-2 focus:outline-none whitespace-nowrap"
            [ngClass]="{'border-westetics-purple-800 text-westetics-purple-800': activeTab === 'photos', 'border-transparent text-gray-500 hover:text-gray-700': activeTab !== 'photos'}">
            Fotos
          </button>
          <button (click)="changeTab('intercorrencias')"
            class="py-3 md:py-4 px-4 md:px-6 font-medium text-sm border-b-2 focus:outline-none whitespace-nowrap"
            [ngClass]="{'border-westetics-purple-800 text-westetics-purple-800': activeTab === 'intercorrencias', 'border-transparent text-gray-500 hover:text-gray-700': activeTab !== 'intercorrencias'}">
            Intercorrência
          </button>
        </nav>

        <div class="flex flex-wrap items-center gap-2 md:gap-4 mb-4 mt-2 md:mt-0">
          <div
            *ngIf="treatmentPlan.status === 'ACTIVE'"
            class="px-2 py-1 md:px-3 md:py-2 inline-block rounded-full text-xs md:text-sm truncate"
            [ngClass]="{
              'bg-gray-100 text-gray-800': !hasUnsavedChanges,
              'bg-red-50 text-red-700 border border-red-300': hasUnsavedChanges
            }">
            <a *ngIf="!hasUnsavedChanges">Salvo: {{ treatmentPlan.updated_at | date:'dd/MM/yyyy HH:mm:ss' }}</a>
            <a *ngIf="hasUnsavedChanges" class="flex items-center">
              <i class="fas fa-exclamation-circle mr-1"></i> Alterações não salvas
            </a>
          </div>
          <div
            *ngIf="treatmentPlan.status === 'CLOSED'"
            class="px-2 py-1 md:px-3 md:py-2 inline-block rounded-full text-xs md:text-sm bg-gray-100 text-gray-800">
            <a>Iniciou em: {{ treatmentPlan.created_at | date:'dd/MM/yyyy HH:mm:ss' }}</a>
          </div>
          <div
            *ngIf="treatmentPlan.status === 'CLOSED'"
            class="px-2 py-1 md:px-3 md:py-2 inline-block rounded-full text-xs md:text-sm bg-gray-100 text-gray-800">
            <a>Encerrou em: {{ treatmentPlan.published_at | date:'dd/MM/yyyy HH:mm:ss' }}</a>
          </div>
          <div class="px-2 py-1 md:px-3 md:py-2 inline-block rounded-full text-xs md:text-sm" [ngClass]="{
                    'bg-blue-100 text-blue-800': treatmentPlan.status === 'ACTIVE',
                    'bg-green-100 text-green-800': treatmentPlan.status === 'CLOSED'
                  }">
            {{ treatmentPlan.status === 'ACTIVE' ? 'Em Aberto' : 'Encerrado' }}
          </div>
          <button *ngIf="treatmentPlan && treatmentPlan.status === 'ACTIVE'"
            (click)="showHelpInfoVisible = !showHelpInfoVisible"
            class="bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white font-medium px-3 py-1 rounded-full flex items-center text-sm md:text-base">
            <fa-icon [icon]="faQuestion"></fa-icon>
          </button>
        </div>
      </div>

      <!-- Aba de Informações Gerais -->
      <div *ngIf="activeTab === 'info'" class="bg-white rounded-lg shadow-md p-4 md:p-6">
        <form [formGroup]="treatmentPlanForm">
          <div class="grid grid-cols-1 xl:grid-cols-2 gap-6 mb-6">
            <div>
              <h2 class="text-lg font-semibold mb-3 md:mb-4">Dados do Paciente</h2>

              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-1">Nome do Paciente</label>
                <div class="flex items-center gap-2">
                  <input type="text" formControlName="patient_name"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100" readonly>
                  <span *ngIf="isModelPatient" class="shrink-0 inline-block px-2 py-0.5 text-xs font-semibold rounded bg-yellow-100 text-yellow-800">
                    Paciente modelo
                  </span>
                </div>
              </div>

              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <div>
                  <label for="patient-age-field" class="block text-sm font-medium text-gray-700 mb-1">Idade*</label>
                  <input id="patient-age-field" type="number" inputmode="numeric" formControlName="patient_age" (blur)="onFieldBlur('patient_age')"
                    class="w-full px-3 py-2 border rounded-md"
                                [ngClass]="{'border-gray-300': treatmentPlanForm.get('patient_age')?.valid || !treatmentPlanForm.get('patient_age')?.touched,
                       'border-red-500': treatmentPlanForm.get('patient_age')?.invalid && treatmentPlanForm.get('patient_age')?.touched}"
                    [disabled]="treatmentPlan.status === 'CLOSED'" placeholder="Informe a idade" min="0" max="120">
                                      <div
                      *ngIf="treatmentPlanForm?.get('patient_age')?.invalid && treatmentPlanForm?.get('patient_age')?.touched"
                    class="text-red-500 text-xs mt-1">
                    Este campo é obrigatório
                  </div>
                </div>

                <div class="mb-4">
                  <label class="block text-sm font-medium text-gray-700 mb-1">Uso de Imagem</label>
                  <div class="flex items-center border border-gray-300 rounded-md bg-gray-100">
                    <div class="flex items-center">
                      <span class="px-3 py-2 bg-gray-100 rounded-md text-sm">
                        {{ treatmentPlan.image_authorization ? 'Autoriza' : 'Não autoriza' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h2 class="text-lg font-semibold mb-3 md:mb-4">Dados do Tratamento</h2>

              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-1">Procedimentos Contratados</label>
                <div class="bg-gray-100 border border-gray-300 rounded-md p-3 min-h-[80px] overflow-auto">
                  <p class="text-sm">{{ treatmentPlan.contracted_procedures }}</p>
                </div>
              </div>

              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-1">Profissional Responsável</label>
                <div class="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 overflow-auto">
                  {{ treatmentPlan.responsible_professional }}
                </div>
              </div>

              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-1">Valor Total</label>
                <input type="text" [value]="formatCurrency(treatmentPlan.total_value)"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100" readonly>
              </div>
            </div>
          </div>

          <div class="flex flex-col gap-4 mb-6">
            <h2 class="text-lg font-semibold">Observações</h2>
            <!-- obs text -->
            <p class="text-xs text-justify">Obs.: Área destinada a observações gerais sobre o plano de aplicação. Utilize este espaço para anotar orientações específicas, recomendações de técnica, detalhes sobre profundidade, volume e pontos de injeção, além de quaisquer considerações pertinentes à segurança e ao resultado estético. Registre aqui notas adicionais que auxiliem no acompanhamento e na revisão do plano de aplicação.</p>
            <!-- Quando o status é ACTIVE, mostra o textarea para edição -->
            <textarea *ngIf="treatmentPlan.status !== 'CLOSED'" formControlName="observations" rows="4" (blur)="onFieldBlur('observations')"
              class="w-full px-3 py-2 border border-gray-300 rounded-md"
              placeholder="Adicione observações sobre o tratamento..." maxlength="10000"></textarea>
            <!-- Quando o status é CLOSED, mostra o div semelhante ao PDF -->
            <div *ngIf="treatmentPlan.status === 'CLOSED'" class="border p-2 bg-gray-50 min-h-[60px] whitespace-pre-wrap break-words">{{
              treatmentPlanForm.get('observations')?.value || '' }}</div>
            <div *ngIf="treatmentPlan.status !== 'CLOSED'" class="flex justify-end mt-1">
              <span class="text-sm text-gray-500">
                {{ treatmentPlanForm.get('observations')?.value?.length || 0 }}/10000 caracteres
              </span>
            </div>
          </div>
        </form>
      </div>

      <!-- Aba de Produtos -->
      <div *ngIf="activeTab === 'products'" class="bg-white rounded-lg shadow-md p-4 md:p-6">
        <!-- Lista de Produtos -->
        <div class="space-y-6 md:space-y-8" [formGroup]="treatmentPlanForm">
          <!-- Produtos existentes e novos -->
          <div *ngFor="let productControl of productsArray.controls; let i = index"
            class="bg-gray-50 border border-gray-200 rounded-lg p-4 md:p-6 mb-4 md:mb-6 relative"
            [formGroup]="getProductFormGroup(i)">
            <!-- Cabeçalho do produto -->
            <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4">
              <h2 class="text-lg md:text-xl font-semibold mb-2 sm:mb-0">Produto {{ i+1 }}</h2>

              <button *ngIf="treatmentPlan.status === 'ACTIVE'"
                (click)="removeConfirmId = getProductFormGroup(i).get('id')?.value || ''; removeConfirmName = getSelectedProductLabel(i) || 'produto'; removeConfirmType = 'product'; showRemoveConfirmModal = true"
                class="text-westetics-purple-800 hover:text-westetics-purple-600 flex items-center">
                <span class="bg-westetics-purple-100 hover:bg-westetics-purple-200 rounded-full w-6 h-6 flex items-center justify-center mr-1">
                  <span class="font-bold">x</span>
                </span>
                <span>Excluir</span>
              </button>
            </div>

            <!-- Formulário do produto -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <div>
                <label for="product-{{i}}-application_date-main" class="block text-sm font-medium text-gray-700 mb-1">Data da Aplicação*:</label>
                <div class="relative">
                  <input id="product-{{i}}-application_date-main" type="text" formControlName="application_date"
                    mask="00/00/0000" [dropSpecialCharacters]="false" inputmode="numeric" autocomplete="off"
                    placeholder="DD/MM/AAAA"
                    [disabled]="treatmentPlan.status === 'CLOSED'" class="w-full px-3 py-2 border rounded-md"
                    [ngClass]="{'border-gray-300': getProductFormGroup(i).get('application_date')?.valid || !getProductFormGroup(i).get('application_date')?.touched, 
                                 'border-red-500': getProductFormGroup(i).get('application_date')?.invalid && getProductFormGroup(i).get('application_date')?.touched}">
                  <div class="absolute inset-y-0 right-0 flex items-center pr-3">
                    <i class="far fa-calendar-alt text-gray-400"></i>
                  </div>
                </div>
                <div
                  *ngIf="getProductFormGroup(i).get('application_date')?.invalid && getProductFormGroup(i).get('application_date')?.touched"
                  class="text-red-500 text-xs mt-1">
                  <ng-container *ngIf="getProductFormGroup(i).get('application_date')?.errors?.['required']; else appDateInvalidMsg">
                    Este campo é obrigatório
                  </ng-container>
                  <ng-template #appDateInvalidMsg>
                    Data inválida.
                  </ng-template>
                </div>
              </div>

              <div>
                <label for="product-{{i}}-manufacturer-main" class="block text-sm font-medium text-gray-700 mb-1">Fabricante*:</label>
                <div class="relative group">
                  <span [id]="'dropdown-button-manufacturer-' + i"
                    class="flex justify-between gap-2 items-center py-1.5 px-2 w-full rounded-md border text-gray-900 shadow-sm cursor-pointer focus:ring-2 focus:ring-westetics-purple-800 sm:text-sm sm:leading-6"
                    [class.border-gray-300]="getProductFormGroup(i).get('manufacturer')?.valid || !getProductFormGroup(i).get('manufacturer')?.touched"
                    [class.border-red-500]="getProductFormGroup(i).get('manufacturer')?.invalid && getProductFormGroup(i).get('manufacturer')?.touched"
                    [class.cursor-not-allowed]="treatmentPlan.status === 'CLOSED'"
                    [class.bg-gray-100]="treatmentPlan.status === 'CLOSED'"
                    (click)="treatmentPlan.status !== 'CLOSED' ? openCloseManufacturerSelect(i) : null">
                    <div class="w-5/6 text-start">{{getSelectedManufacturerLabel(i)}}</div>
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd"
                        d="M6.293 9.293a1 1 0 011.414 0L10 11.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                        clip-rule="evenodd" />
                    </svg>
                  </span>
                  <div [id]="'dropdown-background-manufacturer-' + i"
                    class="hidden bg-neutral-600 bg-opacity-70 fixed inset-0 z-10"
                    (click)="openCloseManufacturerSelect(i)">
                  </div>
                  <div [id]="'dropdown-menu-manufacturer-' + i"
                    class="hidden z-20 absolute w-full max-h-80 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1">
                    <input [id]="'search-input-manufacturer-' + i"
                      class="block w-full px-4 py-2 text-gray-800 border rounded-md border-gray-300 focus:outline-none"
                      type="text" placeholder="Procure fabricantes" autocomplete="off"
                      (keyup)="onManufacturerSearch($event, 'manufacturer-' + i)">
                    <div [id]="'options-list-manufacturer-' + i"
                      class="block w-full max-h-52 overflow-auto p-1 cursor-pointer space-y-1">
                      <div *ngFor="let manufacturer of manufacturersList"
                        class="manufacturer-option flex items-center space-x-2 px-2 hover:bg-westetics-purple-800 hover:text-white rounded-md">
                        <a class="cursor-pointer w-full text-left py-2"
                          (click)="onManufacturerSelect(manufacturer, i)">
                          {{manufacturer}}
                        </a>
                      </div>
                      <div class="manufacturer-option flex items-center space-x-2 px-2 hover:bg-westetics-purple-800 hover:text-white rounded-md">
                        <a class="cursor-pointer w-full text-left py-2"
                          (click)="onManufacturerSelect('Outro', i)">
                          Outro
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="getProductFormGroup(i).get('manufacturer')?.invalid && getProductFormGroup(i).get('manufacturer')?.touched"
                  class="text-red-500 text-xs mt-1">
                  Este campo é obrigatório
                </div>

                <!-- Campo de texto para especificar o fabricante quando "Outro" for selecionado -->
                <div *ngIf="getProductFormGroup(i).get('manufacturer')?.value === 'Outro'" class="mt-2">
                  <label for="product-{{i}}-custom-manufacturer-main" class="sr-only">Especificar Fabricante</label>
                  <input id="product-{{i}}-custom-manufacturer-main" formControlName="custom_manufacturer" type="text" (blur)="onFieldBlur('custom_manufacturer')"
                    placeholder="Especifique o fabricante*" class="w-full px-3 py-2 border rounded-md"
                    [disabled]="treatmentPlan.status === 'CLOSED'"
                    [ngClass]="{'border-gray-300': !getProductFormGroup(i).get('custom_manufacturer')?.invalid || !getProductFormGroup(i).get('custom_manufacturer')?.touched, 
                              'border-red-500': getProductFormGroup(i).get('custom_manufacturer')?.invalid && getProductFormGroup(i).get('custom_manufacturer')?.touched}">
                  <div
                    *ngIf="getProductFormGroup(i).get('custom_manufacturer')?.invalid && getProductFormGroup(i).get('custom_manufacturer')?.touched"
                    class="text-red-500 text-xs mt-1">
                    É necessário especificar o fabricante
                  </div>
                </div>
              </div>

              <div>
                <label for="product-{{i}}-product_name-main" class="block text-sm font-medium text-gray-700 mb-1">Produto*:</label>
                <div class="relative group">
                  <span [id]="'dropdown-button-product-' + i"
                    class="flex justify-between gap-2 items-center py-1.5 px-2 w-full rounded-md border shadow-sm sm:text-sm sm:leading-6"
                    [class.border-gray-300]="getProductFormGroup(i).get('product_name')?.valid || !getProductFormGroup(i).get('product_name')?.touched"
                    [class.border-red-500]="getProductFormGroup(i).get('product_name')?.invalid && getProductFormGroup(i).get('product_name')?.touched"
                    [class.cursor-pointer]="isProductSelectEnabled(i)"
                    [class.cursor-not-allowed]="!isProductSelectEnabled(i)"
                    [class.bg-gray-100]="!isProductSelectEnabled(i)"
                    [class.text-gray-900]="isProductSelectEnabled(i)"
                    [class.text-gray-500]="!isProductSelectEnabled(i)"
                    [class.focus:ring-2]="isProductSelectEnabled(i)"
                    [class.focus:ring-westetics-purple-800]="isProductSelectEnabled(i)"
                    (click)="isProductSelectEnabled(i) ? openCloseProductSelect(i) : null">
                    <div class="w-5/6 text-start">
                      {{ isProductSelectEnabled(i) || treatmentPlan.status === 'CLOSED' ? getSelectedProductLabel(i) : 'Selecione um fabricante primeiro' }}
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="currentColor" aria-hidden="true"
                      [class.text-gray-400]="!isProductSelectEnabled(i)">
                      <path fill-rule="evenodd"
                        d="M6.293 9.293a1 1 0 011.414 0L10 11.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                        clip-rule="evenodd" />
                    </svg>
                  </span>
                  <div [id]="'dropdown-background-product-' + i"
                    class="hidden bg-neutral-600 bg-opacity-70 fixed inset-0 z-10"
                    (click)="openCloseProductSelect(i)">
                  </div>
                  <div [id]="'dropdown-menu-product-' + i"
                    class="hidden z-20 absolute w-full max-h-80 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1">
                    <input [id]="'search-input-product-' + i"
                      class="block w-full px-4 py-2 text-gray-800 border rounded-md border-gray-300 focus:outline-none"
                      type="text" placeholder="Procure produtos" autocomplete="off"
                      (keyup)="onProductSearch($event, 'product-' + i)">
                    <div [id]="'options-list-product-' + i"
                      class="block w-full max-h-52 overflow-auto p-1 cursor-pointer space-y-1">
                      <div *ngFor="let product of availableProducts[i] || []"
                        class="product-option flex items-center space-x-2 px-2 hover:bg-westetics-purple-800 hover:text-white rounded-md">
                        <a class="cursor-pointer w-full text-left py-2"
                          (click)="onProductSelect(product, i)">
                          {{product}}
                        </a>
                      </div>
                      <div class="product-option flex items-center space-x-2 px-2 hover:bg-westetics-purple-800 hover:text-white rounded-md">
                        <a class="cursor-pointer w-full text-left py-2"
                          (click)="onProductSelect('Outro', i)">
                          Outro
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="getProductFormGroup(i).get('product_name')?.invalid && getProductFormGroup(i).get('product_name')?.touched"
                  class="text-red-500 text-xs mt-1">
                  Este campo é obrigatório
                </div>

                <!-- Campo de texto para especificar o produto quando "Outro" for selecionado -->
                <div *ngIf="getProductFormGroup(i).get('product_name')?.value === 'Outro'" class="mt-2">
                  <label for="product-{{i}}-custom-product-name-main" class="sr-only">Especificar Produto</label>
                  <input id="product-{{i}}-custom-product-name-main" formControlName="custom_product_name" type="text" (blur)="onFieldBlur('custom_product_name')"
                    placeholder="Especifique o produto*" class="w-full px-3 py-2 border rounded-md"
                    [disabled]="treatmentPlan.status === 'CLOSED'"
                    [ngClass]="{'border-gray-300': !getProductFormGroup(i).get('custom_product_name')?.invalid || !getProductFormGroup(i).get('custom_product_name')?.touched, 
                              'border-red-500': getProductFormGroup(i).get('custom_product_name')?.invalid && getProductFormGroup(i).get('custom_product_name')?.touched}">
                  <div
                    *ngIf="getProductFormGroup(i).get('custom_product_name')?.invalid && getProductFormGroup(i).get('custom_product_name')?.touched"
                    class="text-red-500 text-xs mt-1">
                    É necessário especificar o produto
                  </div>
                </div>
              </div>

              <!-- Quantidade e Unidade -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Medida Total Aplicada:</label>
                <div class="flex gap-2">
                  <div style="flex: 7;">
                    <input id="product-{{i}}-total-quantity" formControlName="total_quantity" type="text" inputmode="decimal"
                      placeholder="Ex: 4.5"
                      class="w-full px-3 py-1.5 border rounded-md shadow-sm sm:text-sm sm:leading-6 focus:ring-2 focus:ring-westetics-purple-800 focus:border-westetics-purple-800"
                      [disabled]="treatmentPlan.status === 'CLOSED'"
                      [ngClass]="{'border-gray-300': true, 'bg-gray-100 cursor-not-allowed': treatmentPlan.status === 'CLOSED'}"
                      (input)="onTotalQuantityInput($event, i)"
                      (blur)="onTotalQuantityBlur(i)">
                  </div>
                  <div style="flex: 3;">
                    <div class="relative group">
                      <button type="button" [id]="'dropdown-button-unit-' + i"
                        class="flex justify-between gap-2 items-center py-1.5 px-2 w-full rounded-md border text-gray-900 shadow-sm cursor-pointer focus:ring-2 focus:ring-westetics-purple-800 sm:text-sm sm:leading-6"
                        [class.border-gray-300]="true"
                        [class.cursor-not-allowed]="treatmentPlan.status === 'CLOSED'"
                        [class.bg-gray-100]="treatmentPlan.status === 'CLOSED'"
                        [attr.aria-haspopup]="'listbox'"
                        [attr.aria-expanded]="openedUnitDropdowns.includes('unit-' + i)"
                        (click)="treatmentPlan.status !== 'CLOSED' ? openCloseUnitSelect(i) : null">
                        <div class="text-start">{{ getSelectedUnitLabel(i) }}</div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd"
                            d="M6.293 9.293a1 1 0 011.414 0L10 11.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                            clip-rule="evenodd" />
                        </svg>
                      </button>
                      <div [id]="'dropdown-background-unit-' + i"
                        class="hidden bg-neutral-600 bg-opacity-70 fixed inset-0 z-10"
                        (click)="openCloseUnitSelect(i)">
                      </div>
                      <div [id]="'dropdown-menu-unit-' + i"
                        class="hidden z-20 absolute w-full mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1">
                        <div class="block w-full max-h-52 overflow-auto p-1 cursor-pointer space-y-1">
                          <div *ngFor="let unit of unitsList"
                            class="unit-option flex items-center space-x-2 px-2 hover:bg-westetics-purple-800 hover:text-white rounded-md">
                            <button type="button"
                              class="cursor-pointer w-full text-left py-2"
                              (click)="onUnitSelect(unit, i)">
                              {{ unit }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Região de Aplicação - Checkbox Multi-Select -->
            <div class="mb-4" [id]="'product-' + i + '-regions-section'">
              <div class="flex items-center gap-8">
                <h3 class="font-medium text-lg">Regiões de Aplicação*</h3>
                <button *ngIf="treatmentPlan.status === 'ACTIVE'" type="button"
                  (click)="openRegionModal(i)"
                  class="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-westetics-purple-800 bg-westetics-purple-50 border border-westetics-purple-200 rounded-lg hover:bg-westetics-purple-100 transition-colors">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path>
                  </svg>
                  {{ getSelectedRegionsList(i).length > 0 ? 'Editar' : 'Adicionar' }}
                </button>
              </div>

              <!-- Chips das regiões selecionadas -->
              <div class="mt-3">
                <div *ngIf="getSelectedRegionsList(i).length > 0" class="flex flex-wrap gap-2">
                  <span *ngFor="let region of getSelectedRegionsList(i)"
                    class="inline-flex items-start gap-1 px-3 py-1 rounded-2xl text-sm bg-westetics-purple-100 text-westetics-purple-800 max-w-full">
                    <span class="min-w-0 break-all">{{ region.label }}</span>
                    <button *ngIf="treatmentPlan.status === 'ACTIVE'" type="button"
                      (click)="removeRegionByIndex(i, region.index)"
                      class="ml-1 mt-0.5 shrink-0 text-westetics-purple-600 hover:text-red-500 focus:outline-none">
                      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                      </svg>
                    </button>
                  </span>
                </div>
                <p *ngIf="getSelectedRegionsList(i).length === 0" class="text-sm text-gray-500">
                  Nenhuma região selecionada. {{ treatmentPlan.status === 'ACTIVE' ? 'Clique em "Adicionar" para selecionar.' : '' }}
                </p>
              </div>
            </div>

            <!-- Seção de Fotos -->
            <div class="mt-6" [id]="'product-' + i + '-photos-section'">
              <h3 class="font-medium text-lg mb-2">Fotos do Produto*</h3>
              <p class="text-sm text-gray-600 mb-1">Adicione fotos que contenham as informações de lote, quantidade e validade.</p>
              

              <div class="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-4">
                <!-- Frasco -->
                <div class="relative">
                  <h4 *ngIf="hasProductPhoto(getProductFormGroup(i).value, 'bottle') || treatmentPlan.status === 'ACTIVE'" class="text-sm font-medium mb-1">Frasco</h4>
                  
                  <!-- NOVO: Loading individual para foto do frasco -->
                  <div *ngIf="isProductPhotoUploading(getProductFormGroup(i).get('id')?.value || '', 'bottle')" 
                    class="bg-westetics-purple-50 border-2 border-westetics-purple-200 rounded-xl flex items-center justify-center h-36 md:h-48">
                    <div class="flex flex-col items-center text-westetics-purple-600">
                      <app-loading-spinner size="md" class="mb-2"></app-loading-spinner>
                      <span class="text-sm font-medium">Processando foto...</span>
                    </div>
                  </div>

                  <div *ngIf="hasProductPhoto(getProductFormGroup(i).value, 'bottle') && !isProductPhotoUploading(getProductFormGroup(i).get('id')?.value || '', 'bottle')"
                    class="relative bg-gray-50 border border-gray-200 rounded-xl shadow">
                    <div id="product-{{i}}-photo-bottle-existing"
                      class="h-36 md:h-48 flex items-center justify-center p-2 cursor-pointer"
                      (click)="showProductPhotoModal(getProductFormGroup(i).value, 'bottle'); updateImageRendering('bottle', getProductFormGroup(i).get('id')?.value || '')">
                      <img [src]="sanitizeUrl(getProductPhotoUrl(getProductFormGroup(i).value, 'bottle'))"
                        [attr.key]="getProductFormGroup(i).get('id')?.value" alt="Foto do Frasco"
                        class="max-w-full max-h-full object-contain p-2">
                    </div>
                    <div class="p-2 border-t">
                      <button *ngIf="treatmentPlan.status === 'ACTIVE'"
                        (click)="removeConfirmProductId = getProductFormGroup(i).get('id')?.value || ''; removeConfirmProductPhotoType = 'bottle'; removeConfirmType = 'product_photo'; removeConfirmName = 'foto'; showRemoveConfirmModal = true"
                        class="mt-1 px-2 py-1 text-xs bg-westetics-purple-800 text-white rounded hover:bg-westetics-purple-600 w-full flex items-center justify-center">
                        <fa-icon [icon]="faTrash" class="mr-1"></fa-icon>
                        Remover
                      </button>
                    </div>
                  </div>
                  <div *ngIf="!hasProductPhoto(getProductFormGroup(i).value, 'bottle') && !isProductPhotoUploading(getProductFormGroup(i).get('id')?.value || '', 'bottle') && treatmentPlan.status === 'ACTIVE'" id="product-{{i}}-photo-bottle-placeholder"
                    (click)="initPhotoCapture(getProductFormGroup(i).get('id')?.value || '', 'bottle')"
                    class="bg-gray-100 rounded-xl flex items-center justify-center cursor-pointer hover:bg-gray-200 h-36 md:h-48"
                    [class.cursor-not-allowed]="!getProductFormGroup(i).get('id')?.value"
                    [class.opacity-50]="!getProductFormGroup(i).get('id')?.value">
                    <span class="text-gray-400 flex flex-col items-center">
                      <i class="fas fa-plus text-xl md:text-2xl mb-1"></i>
                      <span class="text-xs md:text-sm">Adicionar</span>
                    </span>
                  </div>
                </div>

                <!-- Caixa -->
                <div class="relative">
                  <h4 *ngIf="hasProductPhoto(getProductFormGroup(i).value, 'box') || treatmentPlan.status === 'ACTIVE'" class="text-sm font-medium mb-1">Caixa</h4>
                  
                  <!-- NOVO: Loading individual para foto da caixa -->
                  <div *ngIf="isProductPhotoUploading(getProductFormGroup(i).get('id')?.value || '', 'box')" 
                    class="bg-westetics-purple-50 border-2 border-westetics-purple-200 rounded-xl flex items-center justify-center h-36 md:h-48">
                    <div class="flex flex-col items-center text-westetics-purple-600">
                      <app-loading-spinner size="md" class="mb-2"></app-loading-spinner>
                      <span class="text-sm font-medium">Processando foto...</span>
                    </div>
                  </div>

                  <div *ngIf="hasProductPhoto(getProductFormGroup(i).value, 'box') && !isProductPhotoUploading(getProductFormGroup(i).get('id')?.value || '', 'box')"
                    class="relative bg-gray-50 border border-gray-200 rounded-xl shadow">
                    <div id="product-{{i}}-photo-box-existing"
                      class="h-36 md:h-48 flex items-center justify-center p-2 cursor-pointer"
                      (click)="showProductPhotoModal(getProductFormGroup(i).value, 'box'); updateImageRendering('box', getProductFormGroup(i).get('id')?.value || '')">
                      <img [src]="sanitizeUrl(getProductPhotoUrl(getProductFormGroup(i).value, 'box'))"
                        [attr.key]="getProductFormGroup(i).get('id')?.value" alt="Foto da Caixa"
                        class="max-w-full max-h-full object-contain p-2">
                    </div>
                    <div class="p-2 border-t">
                      <button *ngIf="treatmentPlan.status === 'ACTIVE'"
                        (click)="removeConfirmProductId = getProductFormGroup(i).get('id')?.value || ''; removeConfirmProductPhotoType = 'box'; removeConfirmType = 'product_photo'; removeConfirmName = 'foto'; showRemoveConfirmModal = true"
                        class="mt-1 px-2 py-1 text-xs bg-westetics-purple-800 text-white rounded hover:bg-westetics-purple-600 w-full flex items-center justify-center">
                        <fa-icon [icon]="faTrash" class="mr-1"></fa-icon>
                        Remover
                      </button>
                    </div>
                  </div>
                  <div *ngIf="!hasProductPhoto(getProductFormGroup(i).value, 'box') && !isProductPhotoUploading(getProductFormGroup(i).get('id')?.value || '', 'box') && treatmentPlan.status === 'ACTIVE'" id="product-{{i}}-photo-box-placeholder"
                    (click)="initPhotoCapture(getProductFormGroup(i).get('id')?.value || '', 'box')"
                    class="bg-gray-100 rounded-xl flex items-center justify-center cursor-pointer hover:bg-gray-200 h-36 md:h-48"
                    [class.cursor-not-allowed]="!getProductFormGroup(i).get('id')?.value"
                    [class.opacity-50]="!getProductFormGroup(i).get('id')?.value">
                    <span class="text-gray-400 flex flex-col items-center">
                      <i class="fas fa-plus text-xl md:text-2xl mb-1"></i>
                      <span class="text-xs md:text-sm">Adicionar</span>
                    </span>
                  </div>
                </div>

                <!-- Etiqueta -->
                <div class="relative">
                  <h4 *ngIf="hasProductPhoto(getProductFormGroup(i).value, 'label') || treatmentPlan.status === 'ACTIVE'" class="text-sm font-medium mb-1">Etiqueta</h4>
                  
                  <!-- NOVO: Loading individual para foto da etiqueta -->
                  <div *ngIf="isProductPhotoUploading(getProductFormGroup(i).get('id')?.value || '', 'label')" 
                    class="bg-westetics-purple-50 border-2 border-westetics-purple-200 rounded-xl flex items-center justify-center h-36 md:h-48">
                    <div class="flex flex-col items-center text-westetics-purple-600">
                      <app-loading-spinner size="md" class="mb-2"></app-loading-spinner>
                      <span class="text-sm font-medium">Processando foto...</span>
                    </div>
                  </div>

                  <div *ngIf="hasProductPhoto(getProductFormGroup(i).value, 'label') && !isProductPhotoUploading(getProductFormGroup(i).get('id')?.value || '', 'label')"
                    class="relative bg-gray-50 border border-gray-200 rounded-xl shadow">
                    <div id="product-{{i}}-photo-label-existing"
                      class="h-36 md:h-48 flex items-center justify-center p-2 cursor-pointer"
                      (click)="showProductPhotoModal(getProductFormGroup(i).value, 'label'); updateImageRendering('label', getProductFormGroup(i).get('id')?.value || '')">
                      <img [src]="sanitizeUrl(getProductPhotoUrl(getProductFormGroup(i).value, 'label'))"
                        [attr.key]="getProductFormGroup(i).get('id')?.value" alt="Foto da Etiqueta"
                        class="max-w-full max-h-full object-contain p-2">
                    </div>
                    <div class="p-2 border-t">
                      <button *ngIf="treatmentPlan.status === 'ACTIVE'"
                        (click)="removeConfirmProductId = getProductFormGroup(i).get('id')?.value || ''; removeConfirmProductPhotoType = 'label'; removeConfirmType = 'product_photo'; removeConfirmName = 'foto'; showRemoveConfirmModal = true"
                        class="mt-1 px-2 py-1 text-xs bg-westetics-purple-800 text-white rounded hover:bg-westetics-purple-600 w-full flex items-center justify-center">
                        <fa-icon [icon]="faTrash" class="mr-1"></fa-icon>
                        Remover
                      </button>
                    </div>
                  </div>
                  <div *ngIf="!hasProductPhoto(getProductFormGroup(i).value, 'label') && !isProductPhotoUploading(getProductFormGroup(i).get('id')?.value || '', 'label') && treatmentPlan.status === 'ACTIVE'" id="product-{{i}}-photo-label-placeholder"
                    (click)="initPhotoCapture(getProductFormGroup(i).get('id')?.value || '', 'label')"
                    class="bg-gray-100 rounded-xl flex items-center justify-center cursor-pointer hover:bg-gray-200 h-36 md:h-48"
                    [class.cursor-not-allowed]="!getProductFormGroup(i).get('id')?.value"
                    [class.opacity-50]="!getProductFormGroup(i).get('id')?.value">
                    <span class="text-gray-400 flex flex-col items-center">
                      <i class="fas fa-plus text-xl md:text-2xl mb-1"></i>
                      <span class="text-xs md:text-sm">Adicionar</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Botão para adicionar novo produto -->
          <div *ngIf="treatmentPlan.status === 'ACTIVE'" class="flex justify-center">
            <button (click)="addNewProduct()"
              class="bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white font-medium py-2 px-4 rounded-md flex items-center text-sm md:text-base">
              <span
                class="bg-white text-westetics-purple-800 rounded-full w-5 h-5 md:w-6 md:h-6 flex items-center justify-center mr-2">
                <span class="font-bold">+</span>
              </span>
              Adicionar Novo Produto
            </button>
          </div>

          <!-- Texto informando que não tem produtos -->
          <div *ngIf="productsArray.controls.length === 0 && treatmentPlan.status === 'CLOSED'" class="flex justify-center items-center text-black ">
            <p>Nenhum produto adicionado.</p>
          </div>
        </div>
      </div>

      <!-- Aba de Fotos -->
      <div *ngIf="activeTab === 'photos'" class="bg-white rounded-lg shadow-md p-4 md:p-6">
        <div class="flex justify-between items-center mb-4 md:mb-6">
          <h2 class="text-lg font-semibold">Fotos do Tratamento</h2>
        </div>

        <!-- Seção de Fotos de Marcação -->
        <div class="mb-6 md:mb-8 border border-gray-200 rounded-lg p-4 md:p-6 bg-gray-50">
          <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4">
            <h3 id="marking-photos" class="text-lg md:text-xl font-semibold mb-2 sm:mb-0">Fotos de Marcação</h3>
          </div>

          <p class="text-gray-600 mb-4">Insira fotos da marcação pré-procedimento.</p>

          <div *ngIf="treatmentPlan?.status === 'ACTIVE'" class="flex flex-wrap gap-2 mb-6">
            <button (click)="selectedPhotoType = 'MARKING'; initTreatmentPhotoCapture()"
              class="px-3 py-2 text-sm md:px-4 md:py-2 md:text-base bg-westetics-purple-800 text-white rounded-lg hover:bg-westetics-purple-600 flex items-center">
              <fa-icon [icon]="faAdd" class="mr-2"></fa-icon>
              Adicionar Foto
            </button>
          </div>

          <div *ngIf="loading" class="my-4 text-center text-gray-500">
            <app-loading-spinner size="md" class="mx-auto mb-2"></app-loading-spinner>
            <p>Carregando fotos...</p>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            <div *ngFor="let photo of getMarkingPhotos()"
              class="relative bg-gray-50 rounded-xl shadow border border-gray-200">

              <div *ngIf="isTreatmentPhotoLoading(photo.id!)"
                class="absolute inset-0 bg-white bg-opacity-80 flex flex-col items-center justify-center rounded-xl z-10">
                <app-loading-spinner size="md" class="mb-2"></app-loading-spinner>
                <span class="text-sm font-medium text-indigo-700">
                  {{ deletingPhotoIds.has(photo.id!) ? 'Removendo...' : 'Fazendo upload...' }}
                </span>
              </div>

              <div class="w-full h-40 sm:h-48 flex items-center justify-center p-2 cursor-pointer"
                (click)="showPhotoModal(photo)">
                <img [src]="sanitizeUrl(photo.photo_url)" alt="Foto de Marcação"
                  class="max-w-full max-h-full object-contain rounded-xl">
              </div>
              <div class="p-3 border-t">
                <p class="text-sm font-medium truncate">{{ photo.description }}</p>
                <button *ngIf="treatmentPlan?.status === 'ACTIVE'" (click)="removeConfirmId = photo.id || ''; removeConfirmName = photo.description || 'foto'; removeConfirmType = 'photo'; showRemoveConfirmModal = true"
                  class="mt-1 px-2 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700 w-full flex items-center justify-center">
                  <fa-icon [icon]="faTrash" class="mr-1"></fa-icon>
                  Remover
                </button>
              </div>
            </div>

            <div *ngIf="getMarkingPhotos().length === 0 && !loading"
              class="col-span-full p-4 text-center text-gray-500 bg-gray-100 rounded-lg">
              <p>Ainda não há fotos de marcação. Use o botão "Adicionar Foto" acima para incluir imagens.</p>
            </div>
          </div>
        </div>

        <!-- Seção de Fotos Pré-Tratamento -->
        <div class="mb-6 md:mb-8 border border-gray-200 rounded-lg p-4 md:p-6 bg-gray-50">
          <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4">
            <h3 id="pre-treatment-photos" class="text-lg md:text-xl font-semibold mb-2 sm:mb-0">Fotos do Pré-Tratamento
              (ANTES)</h3>
          </div>

          <p class="text-gray-600 mb-4">Insira fotos da paciente antes do tratamento.</p>

          <div *ngIf="treatmentPlan?.status === 'ACTIVE'" class="flex flex-wrap gap-2 mb-6">
            <button (click)="selectedPhotoType = 'PRE'; initTreatmentPhotoCapture()"
              class="px-3 py-2 text-sm md:px-4 md:py-2 md:text-base bg-westetics-purple-800 text-white rounded-lg hover:bg-westetics-purple-600 flex items-center">
              <fa-icon [icon]="faAdd" class="mr-2"></fa-icon>
              Adicionar Foto
            </button>
          </div>

          <div *ngIf="loading" class="my-4 text-center text-gray-500">
            <app-loading-spinner size="md" class="mx-auto mb-2"></app-loading-spinner>
            <p>Carregando fotos...</p>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            <div *ngFor="let photo of getPreTreatmentPhotos()"
              class="relative bg-gray-50 rounded-xl shadow border border-gray-200">

              <div *ngIf="isTreatmentPhotoLoading(photo.id!)"
                class="absolute inset-0 bg-white bg-opacity-80 flex flex-col items-center justify-center rounded-xl z-10">
                <app-loading-spinner size="md" class="mb-2"></app-loading-spinner>
                <span class="text-sm font-medium text-indigo-700">
                  {{ deletingPhotoIds.has(photo.id!) ? 'Removendo...' : 'Fazendo upload...' }}
                </span>
              </div>

              <div class="w-full h-40 sm:h-48 flex items-center justify-center p-2 cursor-pointer"
                (click)="showPhotoModal(photo)">
                <img [src]="sanitizeUrl(photo.photo_url)" alt="Foto Pré-Procedimento"
                  class="max-w-full max-h-full object-contain rounded-xl">
              </div>
              <div class="p-3 border-t">
                <p class="text-sm font-medium truncate">{{ photo.description }}</p>
                <button *ngIf="treatmentPlan?.status === 'ACTIVE'" (click)="removeConfirmId = photo.id || ''; removeConfirmName = photo.description || 'foto'; removeConfirmType = 'photo'; showRemoveConfirmModal = true"
                  class="mt-1 px-2 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700 w-full flex items-center justify-center">
                  <fa-icon [icon]="faTrash" class="mr-1"></fa-icon>
                  Remover
                </button>
              </div>
            </div>

            <div *ngIf="getPreTreatmentPhotos().length === 0 && !loading"
              class="col-span-full p-4 text-center text-gray-500 bg-gray-100 rounded-lg">
              <p>Ainda não há fotos de pré-tratamento. Use o botão "Adicionar Foto" acima para incluir imagens.</p>
            </div>
          </div>
        </div>

        <!-- Seção de Fotos Pós-Imediato -->
        <div class="mb-6 md:mb-8 border border-gray-200 rounded-lg p-4 md:p-6 bg-gray-50">
          <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4">
            <h3 id="immediate-post-photos" class="text-lg md:text-xl font-semibold mb-2 sm:mb-0">Fotos do Pós-Imediato</h3>
          </div>

          <p class="text-gray-600 mb-4">Insira fotos da paciente logo após o procedimento.</p>

          <div *ngIf="treatmentPlan?.status === 'ACTIVE'" class="flex flex-wrap gap-2 mb-6">
            <button (click)="selectedPhotoType = 'IMMEDIATE_POST'; initTreatmentPhotoCapture()"
              class="px-3 py-2 text-sm md:px-4 md:py-2 md:text-base bg-westetics-purple-800 text-white rounded-lg hover:bg-westetics-purple-600 flex items-center">
              <fa-icon [icon]="faAdd" class="mr-2"></fa-icon>
              Adicionar Foto
            </button>
          </div>

          <div *ngIf="loading" class="my-4 text-center text-gray-500">
            <app-loading-spinner size="md" class="mx-auto mb-2"></app-loading-spinner>
            <p>Carregando fotos...</p>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            <div *ngFor="let photo of getImmediatePostPhotos()"
              class="relative bg-gray-50 rounded-xl shadow border border-gray-200">

              <div *ngIf="isTreatmentPhotoLoading(photo.id!)"
                class="absolute inset-0 bg-white bg-opacity-80 flex flex-col items-center justify-center rounded-xl z-10">
                <app-loading-spinner size="md" class="mb-2"></app-loading-spinner>
                <span class="text-sm font-medium text-indigo-700">
                  {{ deletingPhotoIds.has(photo.id!) ? 'Removendo...' : 'Fazendo upload...' }}
                </span>
              </div>

              <div class="w-full h-40 sm:h-48 flex items-center justify-center p-2 cursor-pointer"
                (click)="showPhotoModal(photo)">
                <img [src]="sanitizeUrl(photo.photo_url)" alt="Foto Pós-Imediato"
                  class="max-w-full max-h-full object-contain rounded-xl">
              </div>
              <div class="p-3 border-t">
                <p class="text-sm font-medium truncate">{{ photo.description }}</p>
                <button *ngIf="treatmentPlan?.status === 'ACTIVE'" (click)="removeConfirmId = photo.id || ''; removeConfirmName = photo.description || 'foto'; removeConfirmType = 'photo'; showRemoveConfirmModal = true"
                  class="mt-1 px-2 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700 w-full flex items-center justify-center">
                  <fa-icon [icon]="faTrash" class="mr-1"></fa-icon>
                  Remover
                </button>
              </div>
            </div>

            <div *ngIf="getImmediatePostPhotos().length === 0 && !loading"
              class="col-span-full p-4 text-center text-gray-500 bg-gray-100 rounded-lg">
              <p>Ainda não há fotos de pós-imediato. Use o botão "Adicionar Foto" acima para incluir imagens.</p>
            </div>
          </div>
        </div>

        <!-- Seção de Fotos Pós-Tratamento -->
        <div class="mb-6 md:mb-8 border border-gray-200 rounded-lg p-4 md:p-6 bg-gray-50">
          <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4">
            <h3 id="post-treatment-photos" class="text-lg md:text-xl font-semibold mb-2 sm:mb-0">Fotos do Pós-Tratamento
              (DEPOIS)</h3>
          </div>

          <p class="text-gray-600 mb-4">Insira fotos da paciente após o tratamento.</p>

          <div *ngIf="treatmentPlan?.status === 'ACTIVE'" class="flex flex-wrap gap-2 mb-6">
            <button (click)="selectedPhotoType = 'POST'; initTreatmentPhotoCapture()"
              class="px-3 py-2 text-sm md:px-4 md:py-2 md:text-base bg-westetics-purple-800 text-white rounded-lg hover:bg-westetics-purple-600 flex items-center">
              <fa-icon [icon]="faAdd" class="mr-2"></fa-icon>
              Adicionar Foto
            </button>
          </div>

          <div *ngIf="loading" class="my-4 text-center text-gray-500">
            <app-loading-spinner size="md" class="mx-auto mb-2"></app-loading-spinner>
            <p>Carregando fotos...</p>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            <div *ngFor="let photo of getPostTreatmentPhotos()"
              class="relative bg-gray-50 rounded-xl shadow border border-gray-200">

              <div *ngIf="isTreatmentPhotoLoading(photo.id!)"
                class="absolute inset-0 bg-white bg-opacity-80 flex flex-col items-center justify-center rounded-xl z-10">
                <app-loading-spinner size="md" class="mb-2"></app-loading-spinner>
                <span class="text-sm font-medium text-indigo-700">
                  {{ deletingPhotoIds.has(photo.id!) ? 'Removendo...' : 'Fazendo upload...' }}
                </span>
              </div>

              <div class="w-full h-40 sm:h-48 flex items-center justify-center p-2 cursor-pointer"
                (click)="showPhotoModal(photo)">
                <img [src]="sanitizeUrl(photo.photo_url)" alt="Foto Pós-Procedimento"
                  class="max-w-full max-h-full object-contain rounded-xl">
              </div>
              <div class="p-3 border-t">
                <p class="text-sm font-medium truncate">{{ photo.description }}</p>
                <button *ngIf="treatmentPlan?.status === 'ACTIVE'" (click)="removeConfirmId = photo.id || ''; removeConfirmName = photo.description || 'foto'; removeConfirmType = 'photo'; showRemoveConfirmModal = true"
                  class="mt-1 px-2 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700 w-full flex items-center justify-center">
                  <fa-icon [icon]="faTrash" class="mr-1"></fa-icon>
                  Remover
                </button>
              </div>
            </div>

            <div *ngIf="getPostTreatmentPhotos().length === 0 && !loading"
              class="col-span-full p-4 text-center text-gray-500 bg-gray-100 rounded-lg">
              <p>Ainda não há fotos de pós-tratamento. Use o botão "Adicionar Foto" acima para incluir imagens.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Aba de Intercorrência: a renderização foi movida para a subrota
           /main/v2/treatment-plan/:id/incident. Clicar na aba acima dispara
           a navegação (changeTab override). Este placeholder só seria visível
           durante o redirect, então fica vazio. -->
      <div *ngIf="activeTab === 'intercorrencias'" class="flex flex-col justify-center items-center py-20">
        <img src="assets/img/Loading.svg" alt="Carregando..." class="w-20 h-20 mb-4">
        <p class="text-sm text-gray-500">Abrindo intercorrência...</p>
      </div>

    </div>
  </div>
</div>

<!-- Modal para visualização de foto em tamanho maior -->
<div *ngIf="selectedViewPhoto"
  class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-2 md:p-0"
  (click)="selectedViewPhoto = null">
  <div class="relative max-w-4xl w-full mx-2 md:mx-4" (click)="$event.stopPropagation()">
    <div class="bg-white rounded-lg overflow-hidden">
      <!-- Cabeçalho com título e botão X alinhados horizontalmente -->
      <div class="flex justify-between items-center p-3 md:p-4 border-b">
        <div class="flex flex-col md:flex-row md:items-center gap-2 md:gap-3 flex-1 mr-3">
          <h3 class="text-base md:text-lg font-medium truncate">{{ selectedViewPhoto.description }}</h3>
          <span class="px-2 py-1 md:px-3 md:py-1 rounded-full text-xs self-start md:self-auto" [ngClass]="{'bg-blue-100 text-blue-800': selectedViewPhoto.type === 'PRE', 
                    'bg-green-100 text-green-800': selectedViewPhoto.type === 'POST'}">
            {{ selectedViewPhoto.type === 'PRE' ? 'Pré-Tratamento' : 'Pós-Tratamento' }}
          </span>
        </div>
        
        <!-- Botão de fechar -->
        <button (click)="selectedViewPhoto = null"
          class="bg-red-600 hover:bg-red-700 rounded-full w-7 h-7 md:w-8 md:h-8 flex items-center justify-center shadow-md flex-shrink-0">
          <span class="text-white font-bold text-lg md:text-xl">×</span>
        </button>
      </div>

      <div class="p-2 md:p-4 flex flex-col">
        <!-- Controles de Zoom -->
        <div class="flex justify-center gap-2 mb-3">
          <button (click)="zoomOut('treatment')" class="bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white rounded-md px-3 py-2 flex items-center justify-center shadow text-sm font-medium">
            <span>−</span>
          </button>
          <button (click)="resetZoom('treatment')" class="bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-md px-3 py-2 text-xs font-medium flex items-center justify-center shadow">
            Redefinir
          </button>
          <button (click)="zoomIn('treatment')" class="bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white rounded-md px-3 py-2 flex items-center justify-center shadow text-sm font-medium">
            <span>+</span>
          </button>
        </div>

        <!-- Área de Zoom/Pan -->
        <div class="overflow-hidden w-full bg-black/5 rounded flex justify-center items-center select-none" style="height: 55vh; max-height: 70vh;"
             (wheel)="onViewWheel($event, 'treatment')"
             (mousedown)="onViewPanStart($event, 'treatment')"
             (mousemove)="onViewPanMove($event, 'treatment')"
             (mouseup)="onViewPanEnd($event, 'treatment')"
             (mouseleave)="onViewPanEnd($event, 'treatment')"
             (touchstart)="onViewPanStart($event, 'treatment')"
             (touchmove)="onViewPanMove($event, 'treatment')"
             (touchend)="onViewPanEnd($event, 'treatment')">
          <img [src]="selectedViewPhoto.photo_url"
               [style.transform]="'translate(' + treatmentTransX + 'px,' + treatmentTransY + 'px) scale(' + treatmentZoom + ')'"
               class="max-h-full max-w-full object-contain cursor-grab select-none"
               draggable="false">
        </div>
      </div>

      <div class="p-3 md:p-4 border-t">
        <p class="text-xs md:text-sm text-gray-500">
          {{ selectedViewPhoto.description }}
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Modal para visualização de foto de produto em tamanho maior -->
<div *ngIf="selectedProductViewPhoto"
  class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-2 md:p-0"
  (click)="selectedProductViewPhoto = null">
  <div class="relative max-w-4xl w-full mx-2 md:mx-4" (click)="$event.stopPropagation()">
    <div class="bg-white rounded-lg overflow-hidden">
      <!-- Cabeçalho com título e botão X alinhados horizontalmente -->
      <div class="flex justify-between items-center p-3 md:p-4 border-b">
        <h3 class="text-base md:text-lg font-medium truncate flex-1 mr-3">{{ getProductPhotoTypeLabel() }}</h3>
        
        <!-- Botão de fechar -->
        <button (click)="selectedProductViewPhoto = null"
          class="bg-red-600 hover:bg-red-700 rounded-full w-7 h-7 md:w-8 md:h-8 flex items-center justify-center shadow-md flex-shrink-0">
          <span class="text-white font-bold text-lg md:text-xl">×</span>
        </button>
      </div>

      <div class="p-2 md:p-4 flex flex-col">
        <!-- Controles de Zoom -->
        <div class="flex justify-center gap-2 mb-3">
          <button (click)="zoomOut('product')" class="bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white rounded-md px-3 py-2 flex items-center justify-center shadow text-sm font-medium">
            <span>−</span>
          </button>
          <button (click)="resetZoom('product')" class="bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-md px-3 py-2 text-xs font-medium flex items-center justify-center shadow">
            Redefinir
          </button>
          <button (click)="zoomIn('product')" class="bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white rounded-md px-3 py-2 flex items-center justify-center shadow text-sm font-medium">
            <span>+</span>
          </button>
        </div>

        <!-- Área de Zoom/Pan -->
        <div class="overflow-hidden w-full bg-black/5 rounded flex justify-center items-center select-none" style="height: 55vh; max-height: 70vh;"
             (wheel)="onViewWheel($event, 'product')"
             (mousedown)="onViewPanStart($event, 'product')"
             (mousemove)="onViewPanMove($event, 'product')"
             (mouseup)="onViewPanEnd($event, 'product')"
             (mouseleave)="onViewPanEnd($event, 'product')"
             (touchstart)="onViewPanStart($event, 'product')"
             (touchmove)="onViewPanMove($event, 'product')"
             (touchend)="onViewPanEnd($event, 'product')">
          <img [src]="sanitizeUrl(selectedProductViewPhoto)"
               [style.transform]="'translate(' + productTransX + 'px,' + productTransY + 'px) scale(' + productZoom + ')'"
               class="max-h-full max-w-full object-contain cursor-grab select-none"
               draggable="false">
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal de confirmação para encerrar tratamento -->
<div *ngIf="showCloseTreatmentModal"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
  <div class="bg-white rounded-lg p-4 md:p-6 max-w-md w-full">
    <div class="flex justify-between items-start mb-4">
      <h3 class="text-base md:text-lg font-medium">Encerrar Tratamento</h3>
      <button (click)="showCloseTreatmentModal = false" class="text-gray-500 hover:text-gray-700">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="mb-4 md:mb-6">
      <p class="text-sm md:text-base text-gray-700 mb-4">Declaro que finalizei todos os procedimentos previstos no plano de tratamento do paciente, conforme as condutas técnicas e éticas aplicáveis.</p>

      <p class="text-sm md:text-base text-gray-700 mb-4">Ao clicar em 'Encerrar Tratamento', estou ciente de que este plano será arquivado de forma definitiva no prontuário, não podendo mais ser editado ou alterado.</p>

      <div class="flex items-center mb-4">
        <input type="checkbox" [(ngModel)]="confirmCloseTreatment" id="confirm-close-treatment"
          class="h-4 w-4 text-westetics-purple-800 focus:ring-westetics-purple-800 border-gray-300 rounded">
        <label for="confirm-close-treatment" class="ml-2 block text-sm text-gray-700">
          Confirmo que todas as informações clínicas foram devidamente registradas.
        </label>
      </div>
    </div>

    <div class="flex justify-end gap-2">
      <button (click)="showCloseTreatmentModal = false"
        class="bg-gray-200 hover:bg-gray-300 text-black font-medium py-2 px-3 md:px-4 rounded-md flex items-center text-sm md:text-base">
        <i class="fas fa-times mr-2"></i>
        Cancelar
      </button>

      <button (click)="confirmCloseTreatmentPlan()" [disabled]="!confirmCloseTreatment"
        [ngClass]="{'bg-westetics-purple-800 hover:bg-westetics-purple-600': confirmCloseTreatment, 'bg-westetics-purple-300 cursor-not-allowed': !confirmCloseTreatment}"
        class="text-white font-medium py-2 px-3 md:px-4 rounded-md flex items-center text-sm md:text-base">
        <i class="fas fa-check mr-2"></i>
        Encerrar Tratamento
      </button>
    </div>
  </div>
</div>

<!-- Modal de progresso de encerramento (fases) -->
<div *ngIf="showPublishingModal"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4">
  <div class="bg-white rounded-2xl shadow-2xl p-6 md:p-8 max-w-md w-full">

    <!-- Cabeçalho com ícone -->
    <div class="flex flex-col items-center text-center mb-6">
      <div *ngIf="publishingPhase !== 'completed'" class="mb-4">
        <img src="assets/img/Loading.svg" alt="Carregando..." class="w-20 h-20" />
      </div>
      <div *ngIf="publishingPhase === 'completed'"
        class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
        <svg class="w-8 h-8 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      </div>

      <h2 class="text-lg md:text-xl font-semibold text-neutral-900">
        <ng-container *ngIf="publishingPhase !== 'completed'">Finalizando plano de tratamento</ng-container>
        <ng-container *ngIf="publishingPhase === 'completed'">Tudo pronto!</ng-container>
      </h2>
      <p *ngIf="publishingPhase !== 'completed'" class="text-sm text-neutral-600 mt-1">
        Por favor, aguarde enquanto finalizamos o processo.
      </p>
      <p *ngIf="publishingPhase === 'completed'" class="text-sm text-neutral-600 mt-1">
        Plano encerrado e enviado para o paciente com sucesso.
      </p>
    </div>

    <!-- Lista de fases (visível enquanto está processando) -->
    <div *ngIf="publishingPhase !== 'completed'" class="space-y-3 mb-2">
      <!-- Fase 1: Salvando informações -->
      <div class="flex items-center gap-3">
        <div class="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors"
          [ngClass]="{
            'bg-westetics-purple-100': isPublishingPhaseActive('saving'),
            'bg-westetics-purple-600': isPublishingPhaseComplete('saving'),
            'bg-neutral-100': !isPublishingPhaseActive('saving') && !isPublishingPhaseComplete('saving')
          }">
          <img *ngIf="isPublishingPhaseActive('saving')" src="assets/img/Loading.svg" alt="Carregando..." class="w-6 h-6" />
          <svg *ngIf="isPublishingPhaseComplete('saving')" class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path>
          </svg>
        </div>
        <span class="text-sm md:text-base transition-colors"
          [ngClass]="{
            'text-neutral-900 font-medium': isPublishingPhaseActive('saving'),
            'text-neutral-600': isPublishingPhaseComplete('saving'),
            'text-neutral-400': !isPublishingPhaseActive('saving') && !isPublishingPhaseComplete('saving')
          }">
          Salvando informações
        </span>
      </div>

      <!-- Fase 2: Encerrando o Plano -->
      <div class="flex items-center gap-3">
        <div class="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors"
          [ngClass]="{
            'bg-westetics-purple-100': isPublishingPhaseActive('closing'),
            'bg-westetics-purple-600': isPublishingPhaseComplete('closing'),
            'bg-neutral-100': !isPublishingPhaseActive('closing') && !isPublishingPhaseComplete('closing')
          }">
          <img *ngIf="isPublishingPhaseActive('closing')" src="assets/img/Loading.svg" alt="Carregando..." class="w-6 h-6" />
          <svg *ngIf="isPublishingPhaseComplete('closing')" class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path>
          </svg>
        </div>
        <span class="text-sm md:text-base transition-colors"
          [ngClass]="{
            'text-neutral-900 font-medium': isPublishingPhaseActive('closing'),
            'text-neutral-600': isPublishingPhaseComplete('closing'),
            'text-neutral-400': !isPublishingPhaseActive('closing') && !isPublishingPhaseComplete('closing')
          }">
          Encerrando o Plano
        </span>
      </div>

      <!-- Fase 3: Gerando e enviando documento para o Paciente -->
      <div class="flex items-center gap-3">
        <div class="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors"
          [ngClass]="{
            'bg-westetics-purple-100': isPublishingPhaseActive('generating'),
            'bg-westetics-purple-600': isPublishingPhaseComplete('generating'),
            'bg-neutral-100': !isPublishingPhaseActive('generating') && !isPublishingPhaseComplete('generating')
          }">
          <img *ngIf="isPublishingPhaseActive('generating')" src="assets/img/Loading.svg" alt="Carregando..." class="w-6 h-6" />
          <svg *ngIf="isPublishingPhaseComplete('generating')" class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path>
          </svg>
        </div>
        <span class="text-sm md:text-base transition-colors"
          [ngClass]="{
            'text-neutral-900 font-medium': isPublishingPhaseActive('generating'),
            'text-neutral-600': isPublishingPhaseComplete('generating'),
            'text-neutral-400': !isPublishingPhaseActive('generating') && !isPublishingPhaseComplete('generating')
          }">
          Gerando e enviando documento para o Paciente
        </span>
      </div>
    </div>

    <!-- Botão Entendi (aparece só quando concluído) -->
    <button *ngIf="publishingPhase === 'completed'" (click)="closePublishingModal()"
      class="w-full py-3 px-4 mt-2 rounded-lg font-medium text-white transition-all duration-200 bg-westetics-purple-800 hover:bg-westetics-purple-600">
      Entendi
    </button>
  </div>
</div>

<!-- Modal de confirmação para remover item -->
<div *ngIf="showRemoveConfirmModal"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
  <div class="bg-white rounded-lg p-4 md:p-6 max-w-md w-full">
    <div class="flex justify-between items-start mb-4">
      <h3 class="text-base md:text-lg font-medium">Confirmar Remoção</h3>
      <button (click)="cancelRemoveConfirm()" [disabled]="removeConfirmLoading" class="text-gray-500 hover:text-gray-700" [class.opacity-50]="removeConfirmLoading">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="mb-4 md:mb-6">
      <p class="text-sm md:text-base text-gray-700 mb-4">
        <ng-container *ngIf="removeConfirmType === 'product'">Tem certeza que deseja remover o produto: <span class="font-medium">{{ removeConfirmName }}</span>?</ng-container>
        <ng-container *ngIf="removeConfirmType !== 'product'">Tem certeza que deseja remover a foto?</ng-container>
      </p>
      <p class="text-xs md:text-sm text-westetics-purple-600">Esta ação não pode ser desfeita.</p>
    </div>

    <div class="flex justify-end gap-2">
      <button (click)="cancelRemoveConfirm()" [disabled]="removeConfirmLoading"
        class="text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 border font-medium py-2 px-3 md:px-4 rounded-md flex items-center text-sm md:text-base"
        [class.opacity-50]="removeConfirmLoading" [class.cursor-not-allowed]="removeConfirmLoading">
        Cancelar
      </button>

      <button (click)="removeConfirmType === 'product' ? confirmRemoveProduct() : (removeConfirmType === 'product_photo' ? confirmRemoveProductPhoto() : confirmRemovePhoto())"
        [disabled]="removeConfirmLoading"
        class="bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white font-medium py-2 px-3 md:px-4 rounded-md flex items-center justify-center gap-2 text-sm md:text-base min-w-[120px]"
        [class.opacity-75]="removeConfirmLoading" [class.cursor-not-allowed]="removeConfirmLoading">
        <app-loading-spinner *ngIf="removeConfirmLoading" size="sm"></app-loading-spinner>
        {{ removeConfirmLoading ? 'Removendo...' : 'Remover' }}
      </button>
    </div>
  </div>
</div>

<!-- Modal de QR Code -->
<div *ngIf="showQrCode" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
  <div class="bg-white rounded-2xl shadow-xl max-w-md w-full max-h-[90vh] overflow-hidden relative flex flex-col">
    
    <!-- Header do Modal -->
    <div class="flex-shrink-0 flex justify-between items-center p-4 border-b border-gray-200">
      <h3 class="text-lg font-semibold text-westetics-neutral-950">{{ getQrCodeTitle() }}</h3>
      <button (click)="closeQrCode()"
        class="text-westetics-neutral-600 hover:text-westetics-neutral-900 hover:bg-gray-100 rounded-full w-8 h-8 flex items-center justify-center transition-colors">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>

    <!-- Conteúdo do Modal (com scroll) -->
    <div class="overflow-y-auto flex-1 p-4 md:p-6">
      
      <!-- Instruções -->
      <div class="mb-4 text-center">
        <p class="text-sm font-medium text-westetics-neutral-950 mb-3">Siga os passos abaixo:</p>
        <ol class="space-y-2 text-sm text-westetics-neutral-800 inline-block text-left">
          <li class="flex items-start gap-2">
            <span class="flex-shrink-0 w-5 h-5 bg-westetics-purple-100 text-westetics-purple-800 rounded-full flex items-center justify-center text-xs font-medium">1</span>
            <span>Leia o QR Code abaixo com a câmera do seu dispositivo móvel ou use o link direto</span>
          </li>
          <li class="flex items-start gap-2">
            <span class="flex-shrink-0 w-5 h-5 bg-westetics-purple-100 text-westetics-purple-800 rounded-full flex items-center justify-center text-xs font-medium">2</span>
            <span>Mantenha este popup aberto e tire as fotos do produto</span>
          </li>
        </ol>
      </div>

      <!-- Seção do QR Code -->
      <div class="bg-gray-50 rounded-xl p-4 md:p-6 mb-4">
        <div class="flex flex-col items-center">
          <!-- QR Code -->
          <div class="bg-white p-4 rounded-lg shadow-sm border border-gray-200 mb-4">
            <!-- qrCodeLoading + qrCodeUrl herdados de TreatmentPlanComponent.
                 *ngIf evita render quando vazio; allowEmptyString silencia
                 warning do angularx-qrcode em transições de change detection. -->
            <qrcode *ngIf="!qrCodeLoading && qrCodeUrl"
              [qrdata]="qrCodeUrl" 
              [allowEmptyString]="true"
              [width]="isMobile ? 200 : 250" 
              [errorCorrectionLevel]="'L'" 
              [colorDark]="'#000000'"
              [colorLight]="'#FFFFFF'"
              [margin]="2">
            </qrcode>
          </div>
          
          <!-- Aviso de expiração -->
          <div class="flex items-center gap-1 text-amber-600 mb-4">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="text-xs font-medium">QR Code expira em até 1h</span>
          </div>
          
          <!-- Mensagem de erro se houver -->
          <div *ngIf="errorMessage" class="w-full mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
            <p class="text-xs text-red-600 text-center flex items-center justify-center gap-1">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              {{ errorMessage }}
            </p>
          </div>
        </div>
        
        <!-- Link direto -->
        <div class="border-t border-gray-200 pt-4 mt-2">
          <p class="text-xs font-medium text-westetics-neutral-700 mb-3 text-center">Ou use o link direto:</p>
          
          <div class="flex justify-center">
            <button 
              (click)="copyQrCodeLink()"
              class="bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white text-sm py-2.5 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 16H6C4.89543 16 4 15.1046 4 14V6C4 4.89543 4.89543 4 6 4H14C15.1046 4 16 4.89543 16 6V8M10 20H18C19.1046 20 20 19.1046 20 18V10C20 8.89543 19.1046 8 18 8H10C8.89543 8 8 8.89543 8 10V18C8 19.1046 8.89543 20 10 20Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Copiar Link
            </button>
          </div>
          
          <!-- Dica -->
          <div class="mt-3 p-3 bg-westetics-purple-50 border border-westetics-purple-100 rounded-lg">
            <p class="text-xs text-westetics-purple-700 text-center flex items-center justify-center gap-1">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Se o QR Code não funcionar, copie o link e envie por WhatsApp
            </p>
          </div>
        </div>
      </div>

      <!-- Passo 3 - Confirmação -->
      <div class="mb-4 text-center">
        <p class="text-sm text-westetics-neutral-800 mb-3 inline-flex items-start gap-2">
          <span class="flex-shrink-0 w-5 h-5 bg-westetics-purple-100 text-westetics-purple-800 rounded-full flex items-center justify-center text-xs font-medium">3</span>
          <span>Quando finalizar, confirme no botão abaixo</span>
        </p>
      </div>

      <!-- Checkbox e Botão de Confirmação -->
      <div class="border-t border-gray-200 pt-4">
        <label class="flex items-center justify-center gap-3 mb-4 cursor-pointer">
          <input type="checkbox" id="confirm-photos-finished-checkbox" [(ngModel)]="qrCodePhotosFinishedCheckbox"
            class="w-5 h-5 text-westetics-purple-800 bg-gray-100 border-gray-300 rounded focus:ring-westetics-purple-500 focus:ring-2">
          <span class="text-sm font-medium text-westetics-neutral-950">
            Confirmo que terminei de tirar todas as fotos
          </span>
        </label>

        <button (click)="refreshPhotos()" [disabled]="!qrCodePhotosFinishedCheckbox"
          class="w-full bg-westetics-purple-800 text-white font-medium py-3 px-4 rounded-lg flex items-center justify-center gap-2 text-sm transition-colors"
          [ngClass]="{'opacity-50 cursor-not-allowed': !qrCodePhotosFinishedCheckbox, 'hover:bg-westetics-purple-600': qrCodePhotosFinishedCheckbox}">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Tirei todas as fotos
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de opções de upload para produtos e tratamentos -->
<div *ngIf="showUploadOptions" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
  <div class="bg-white rounded-lg p-4 md:p-6 max-w-sm w-full relative">
    <!-- Loading overlay para conversão HEIC -->
    <div *ngIf="processingHeic || processingProductHeic" class="absolute inset-0 bg-white bg-opacity-90 flex flex-col items-center justify-center rounded-lg z-10">
      <app-loading-spinner size="lg" class="mb-4"></app-loading-spinner>
      <p class="text-sm text-gray-600">Processando imagem...</p>
    </div>

    <div class="flex justify-between items-start mb-4 gap-3">
      <h3 class="text-base md:text-lg font-medium flex-1 min-w-0">
        <span *ngIf="currentUploadType === 'product'">Adicionar Foto(s) do {{ getPhotoTypeLabel() }}</span>
        <span *ngIf="currentUploadType === 'treatment'">Adicionar Foto(s) do Tratamento</span>
      </h3>
      <button type="button" (click)="showUploadOptions = false; clearPhotoPreview()"
        class="text-gray-500 hover:text-gray-700 flex-shrink-0 leading-none p-1 -mt-1 -mr-1 text-2xl" aria-label="Fechar">
        &times;
      </button>
    </div>

    <!-- Informação sobre disponibilidade de câmera -->
    <div *ngIf="!isMobileDevice() && !hasCamera" class="mb-4 p-3 bg-yellow-50 border-l-4 border-yellow-400">
      <div class="flex">
        <div class="flex-shrink-0">
          <i class="fas fa-exclamation-triangle text-yellow-400"></i>
        </div>
        <div class="ml-3">
          <p class="text-sm text-yellow-700">
            Câmera não detectada neste dispositivo. Use a opção "Galeria" para selecionar uma imagem.
          </p>
        </div>
      </div>
    </div>

    <div class="flex flex-col space-y-3 md:space-y-4 mb-2 md:mb-4">
      <!-- Botão de câmera - sempre mostrar, mas com estilos diferentes baseado na disponibilidade -->
      <button (click)="selectCaptureOption('camera')"
        [disabled]="processingHeic || processingProductHeic || !hasCamera"
        [ngClass]="{
          'bg-gray-50 hover:bg-gray-100 border-gray-200': (isMobileDevice() || hasCamera) && !processingHeic && !processingProductHeic,
          'bg-gray-200 border-gray-300 opacity-60': (!isMobileDevice() && !hasCamera) || processingHeic || processingProductHeic
        }"
        class="flex items-center justify-between p-3 md:p-4 rounded-lg border disabled:cursor-not-allowed">
        <div class="flex items-center">
          <i class="fas fa-camera text-lg md:text-xl mr-3"
             [ngClass]="{
               'text-westetics-purple-800': isMobileDevice() || hasCamera,
               'text-gray-400': !isMobileDevice() && !hasCamera
             }"></i>
          <div class="text-left">
            <span class="text-sm md:text-base block">Tirar Foto</span>
            <span *ngIf="!isMobileDevice() && !hasCamera" class="text-xs text-gray-500">Câmera não disponível</span>
          </div>
        </div>
        <i class="fas fa-chevron-right text-gray-400"></i>
      </button>

      <!-- Botão de galeria (múltipla para tratamento, única para produto) -->
      <button (click)="selectCaptureOption('gallery')"
        [disabled]="processingHeic || processingProductHeic"
        [ngClass]="{
          'bg-gray-50 hover:bg-gray-100 border-gray-200': !processingHeic && !processingProductHeic,
          'bg-gray-200 border-gray-300 opacity-60': processingHeic || processingProductHeic
        }"
        class="flex items-center justify-between p-3 md:p-4 rounded-lg border disabled:cursor-not-allowed">
        <div class="flex items-center">
          <i class="fas fa-images text-lg md:text-xl text-westetics-purple-800 mr-3"></i>
          <div class="text-left">
            <span class="text-sm md:text-base block">Galeria</span>
            <span class="text-xs text-gray-500" *ngIf="currentUploadType === 'treatment'">Selecionar uma ou várias imagens</span>
            <span class="text-xs text-gray-500" *ngIf="currentUploadType === 'product'">Selecionar uma imagem</span>
          </div>
        </div>
        <i class="fas fa-chevron-right text-gray-400"></i>
      </button>

      <button
        (click)="selectCaptureOption('qrcode')"
        [disabled]="processingHeic || processingProductHeic"
        [ngClass]="{
          'bg-gray-50 hover:bg-gray-100 border-gray-200': !processingHeic && !processingProductHeic,
          'bg-gray-200 border-gray-300 opacity-60': processingHeic || processingProductHeic
        }"
        class="flex items-center justify-between p-3 md:p-4 rounded-lg border disabled:cursor-not-allowed">
        <div class="flex items-center">
          <i class="fas fa-qrcode text-lg md:text-xl text-westetics-purple-800 mr-3"></i>
          <div class="text-left">
            <span class="text-sm md:text-base block">Código QR</span>
            <span class="text-xs text-gray-500">Usar dispositivo móvel</span>
          </div>
        </div>
        <i class="fas fa-chevron-right text-gray-400"></i>
      </button>
    </div>
  </div>
</div>

<!-- Input de arquivo oculto para múltiplas fotos de tratamento -->
<input id="treatment-photo-input-multiple" type="file" multiple accept="image/*,.heic,.HEIC,.heif,.HEIF" (change)="onMultiplePhotosSelected($event)"
  style="display: none;">

<!-- Input de arquivo oculto para foto única de produto -->
<input id="product-photo-input-single" type="file" accept="image/*,.heic,.HEIC,.heif,.HEIF" (change)="onSinglePhotoSelected($event)"
  style="display: none;">

<!-- Adicionar estilos para ocultar a barra de rolagem -->
<style>
  .hide-scrollbar::-webkit-scrollbar {
    display: none;
  }

  .hide-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
</style>

<!-- Modal de câmera para captura em tempo real -->
<div *ngIf="isCameraActive" class="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg p-4 max-w-lg w-full mx-4 relative">
    
    <!-- Cabeçalho do modal de câmera -->
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-lg font-medium text-gray-900">
        Capturar Foto
        <span *ngIf="currentUploadType === 'product'" class="text-sm text-gray-600 block">
          {{ getPhotoTypeLabel() }}
        </span>
        <span *ngIf="currentUploadType === 'treatment'" class="text-sm text-gray-600 block">
          Foto {{ selectedPhotoType === 'PRE' ? 'Pré-Tratamento' : 'Pós-Tratamento' }}
        </span>
      </h3>
      
      <!-- Botão de fechar -->
      <button (click)="stopCamera(); isCameraActive = false" 
              class="bg-red-600 text-white px-3 py-1 rounded-md hover:bg-red-700 transition-colors">
        <span class="text-sm font-medium">✕ Fechar</span>
      </button>
    </div>

    <!-- Área do vídeo da câmera -->
    <div class="relative bg-black rounded-lg overflow-hidden mb-4">
      <video id="camera-video" 
             autoplay 
             playsinline 
             muted
             class="w-full h-64 object-cover">
      </video>
      
      <!-- Overlay de loading enquanto câmera carrega -->
      <div *ngIf="!cameraStream" class="absolute inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75">
        <div class="text-white text-center">
          <app-loading-spinner size="md" class="mx-auto mb-2"></app-loading-spinner>
          <p class="text-sm">Inicializando câmera...</p>
        </div>
      </div>
    </div>

    <!-- Botões de ação -->
    <div class="flex justify-center space-x-4">
      <button (click)="capturePhoto()" 
              [disabled]="!cameraStream"
              class="bg-westetics-purple-800 text-white px-6 py-2 rounded-md hover:bg-westetics-purple-600 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors">
        📷 Capturar Foto
      </button>
      
      <button (click)="stopCamera(); isCameraActive = false; showUploadOptions = true" 
              class="bg-gray-600 text-white px-6 py-2 rounded-md hover:bg-gray-700 transition-colors">
        Cancelar
      </button>
    </div>
    
    <!-- Informações da câmera (apenas para debug) -->
    <div *ngIf="cameraStream" class="mt-2 text-xs text-gray-500 text-center">
      Câmera ativa • Clique em "Capturar Foto" quando estiver pronto
    </div>
  </div>
</div>

<!-- Modal de progresso para upload múltiplo -->
<div *ngIf="showMultipleUploadProgress" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
  <div class="bg-white rounded-lg p-4 md:p-6 max-w-md w-full relative">
    <div class="text-center">
      <h3 class="text-base md:text-lg font-medium mb-4">
        Fazendo Upload das Fotos
      </h3>
      
      <!-- Progresso geral -->
      <div class="mb-4">
        <div class="flex justify-between text-sm text-gray-600 mb-2">
          <span>Foto {{ currentFileIndex }} de {{ totalFilesToUpload }}</span>
          <span>{{ multipleUploadProgress.toFixed(0) }}%</span>
        </div>
        <div class="w-full bg-gray-200 rounded-full h-2.5">
          <div 
            class="bg-westetics-purple-800 h-2.5 rounded-full transition-all duration-300" 
            [style.width.%]="multipleUploadProgress">
          </div>
        </div>
      </div>
      
      <!-- Nome do arquivo atual -->
      <div class="mb-4 p-3 bg-gray-50 rounded-lg">
        <p class="text-sm text-gray-600 mb-1">Processando:</p>
        <p class="text-sm font-medium text-gray-800 truncate">{{ currentUploadFileName }}</p>
      </div>
      
      <!-- Ícone de loading -->
      <div class="flex justify-center">
        <app-loading-spinner size="md"></app-loading-spinner>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Seleção de Regiões de Aplicação -->
<div *ngIf="regionModalOpen[regionModalProductIndex]"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overscroll-contain"
  (wheel)="$event.stopPropagation()"
  (touchmove)="$event.stopPropagation()">
  <div class="bg-white rounded-xl shadow-2xl w-full max-w-4xl flex flex-col" style="max-height: 85vh;"
    (wheel)="$event.stopPropagation()">

    <!-- Header do modal -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200 shrink-0">
      <div>
        <h3 class="text-lg font-semibold text-gray-900">Regiões de Aplicação</h3>
        <p class="text-sm text-gray-500 mt-0.5">
          {{ getSelectedRegionsList(regionModalProductIndex).length }} região(ões) selecionada(s)
        </p>
      </div>
      <button type="button" (click)="closeRegionModal(regionModalProductIndex)"
        class="text-gray-400 hover:text-gray-600 transition-colors">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Campo de busca -->
    <div class="px-6 py-3 border-b border-gray-200 bg-gray-50 shrink-0">
      <div class="relative">
        <svg class="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
        </svg>
        <input
          type="text"
          placeholder="Filtrar regiões..."
          [value]="regionSearchFilters[regionModalProductIndex] || ''"
          (input)="onRegionFilterChange(regionModalProductIndex, $event)"
          class="w-full pl-9 pr-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-westetics-purple-800 focus:border-westetics-purple-800">
      </div>
    </div>

    <!-- Corpo do modal: duas colunas com scroll independente -->
    <div class="flex-1 min-h-0 flex flex-col overflow-hidden">
      <div class="flex-1 min-h-0 flex flex-col md:flex-row divide-y md:divide-y-0 md:divide-x divide-gray-200">

        <!-- Coluna: Facial -->
        <div class="flex-1 min-h-0 flex flex-col md:w-1/2">
          <div class="px-4 py-3 bg-gray-50 border-b border-gray-200 shrink-0">
            <h4 class="text-xs font-bold text-gray-500 uppercase tracking-wider">Facial</h4>
          </div>
          <div class="flex-1 min-h-0 overflow-y-auto overscroll-contain px-4 py-2">
            <div *ngFor="let region of getFilteredFacialRegions(regionModalProductIndex); let i = index" class="flex items-center gap-2.5 py-1.5">
              <input type="checkbox"
                [id]="'region-modal-facial-' + regionModalProductIndex + '-' + i"
                [checked]="isRegionSelected(regionModalProductIndex, region)"
                (change)="toggleRegionCheckbox(regionModalProductIndex, region)"
                class="w-4 h-4 shrink-0 text-westetics-purple-800 border-gray-300 rounded focus:ring-westetics-purple-800 cursor-pointer" />
              <label [for]="'region-modal-facial-' + regionModalProductIndex + '-' + i"
                class="text-sm text-gray-700 cursor-pointer select-none">{{ region }}</label>
            </div>
            <div *ngIf="getFilteredFacialRegions(regionModalProductIndex).length === 0 && regionSearchFilters[regionModalProductIndex]"
              class="text-sm text-gray-400 py-3 text-center">Nenhuma facial encontrada</div>
          </div>
        </div>

        <!-- Coluna: Corporal -->
        <div class="flex-1 min-h-0 flex flex-col md:w-1/2">
          <div class="px-4 py-3 bg-gray-50 border-b border-gray-200 shrink-0">
            <h4 class="text-xs font-bold text-gray-500 uppercase tracking-wider">Corporal</h4>
          </div>
          <div class="flex-1 min-h-0 overflow-y-auto overscroll-contain px-4 py-2">
            <div *ngFor="let region of getFilteredCorporalRegions(regionModalProductIndex); let i = index" class="flex items-center gap-2.5 py-1.5">
              <input type="checkbox"
                [id]="'region-modal-corporal-' + regionModalProductIndex + '-' + i"
                [checked]="isRegionSelected(regionModalProductIndex, region)"
                (change)="toggleRegionCheckbox(regionModalProductIndex, region)"
                class="w-4 h-4 shrink-0 text-westetics-purple-800 border-gray-300 rounded focus:ring-westetics-purple-800 cursor-pointer" />
              <label [for]="'region-modal-corporal-' + regionModalProductIndex + '-' + i"
                class="text-sm text-gray-700 cursor-pointer select-none">{{ region }}</label>
            </div>
            <div *ngIf="getFilteredCorporalRegions(regionModalProductIndex).length === 0 && regionSearchFilters[regionModalProductIndex]"
              class="text-sm text-gray-400 py-3 text-center">Nenhuma corporal encontrada</div>
          </div>
        </div>

      </div>

      <!-- Nenhum resultado global -->
      <div *ngIf="getFilteredFacialRegions(regionModalProductIndex).length === 0 && getFilteredCorporalRegions(regionModalProductIndex).length === 0 && regionSearchFilters[regionModalProductIndex]"
        class="text-sm text-gray-500 py-4 px-6 text-center border-t border-gray-200 shrink-0">
        Nenhuma região encontrada para "{{ regionSearchFilters[regionModalProductIndex] }}"
      </div>
    </div>

    <!-- Adicionar região personalizada + Botão Concluir -->
    <div class="px-6 py-4 border-t border-gray-200 bg-gray-50 shrink-0">
      <!-- Região personalizada -->
      <div class="mb-3">
        <label class="block text-sm font-medium text-gray-700 mb-1">Adicionar região personalizada</label>
        <div class="flex gap-2">
          <input type="text"
            [value]="customRegionInput[regionModalProductIndex] || ''"
            (input)="customRegionInput[regionModalProductIndex] = $any($event.target).value"
            (keyup.enter)="addCustomRegion(regionModalProductIndex)"
            placeholder="Ex: Região específica..."
            class="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-westetics-purple-800">
          <button type="button" (click)="addCustomRegion(regionModalProductIndex)"
            class="px-4 py-2 text-sm bg-westetics-purple-800 text-white rounded-md hover:bg-westetics-purple-900 focus:outline-none transition-colors">
            Adicionar
          </button>
        </div>

        <!-- Lista de regiões personalizadas já adicionadas -->
        <div *ngIf="getCustomRegionsList(regionModalProductIndex).length > 0" class="mt-3">
          <p class="text-xs font-medium text-gray-600 mb-1.5">Regiões personalizadas adicionadas:</p>
          <div class="flex flex-wrap gap-1.5">
            <span *ngFor="let custom of getCustomRegionsList(regionModalProductIndex)"
              class="inline-flex items-center gap-1.5 px-2 py-1 text-xs bg-westetics-purple-100 text-westetics-purple-900 rounded-md border border-westetics-purple-200">
              <span>{{ custom.label }}</span>
              <button type="button"
                (click)="removeRegionByIndex(regionModalProductIndex, custom.index)"
                [attr.aria-label]="'Remover ' + custom.label"
                class="text-westetics-purple-800 hover:text-westetics-purple-900 focus:outline-none">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
              </button>
            </span>
          </div>
        </div>
      </div>
      <!-- Botão concluir -->
      <button type="button" (click)="closeRegionModal(regionModalProductIndex)"
        class="w-full px-4 py-2.5 text-sm font-medium bg-westetics-purple-800 text-white rounded-lg hover:bg-westetics-purple-900 focus:outline-none transition-colors">
        Concluir
      </button>
    </div>

  </div>
</div>